import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { JobMatchesGrid } from "./JobMatchesGrid";
import { getCandidateJobMatches } from "../../../../actions/candidates_actions";
import { useSelector, useDispatch } from "react-redux";

export const JobMatches = ({
  candidateDetails,
  candidateStyles,
  candidateInterestsScore,
  isOnPrintMode,
}) => {
  const dispatch = useDispatch();
  const { normalJobMatches, techJobMatches } = useSelector(
    (state) => state.candidates.selectedCandidateData
  );

  useEffect(() => {
    async function loadJobs() {
      try {
        dispatch(getCandidateJobMatches());
      } catch (error) {
        console.log(error);
      }
    }
    if (!techJobMatches) {
      loadJobs();
    }
  }, [dispatch, techJobMatches]);

  if (!normalJobMatches || !techJobMatches) {
    return null;
  }

  return (
    <Grid container direction="column">
      <Grid item>
        <JobMatchesGrid
          isOnPrintMode={isOnPrintMode}
          type="tech"
          jobs={techJobMatches}
          candidateStyles={candidateStyles}
          candidateInterestsScore={candidateInterestsScore}
        />
      </Grid>
      <Grid item size>
        <JobMatchesGrid
          isOnPrintMode={isOnPrintMode}
          type="normal"
          jobs={normalJobMatches}
          candidateStyles={candidateStyles}
          candidateInterestsScore={candidateInterestsScore}
        />
      </Grid>
    </Grid>
  );
};
